import { Link } from "gatsby"
import React from "react"
import {
  isLocaleIncludedToURL,
  isMuditaLink,
  resolveLink,
} from "./link.helpers"
import { Link as TranslationLink } from "gatsby-plugin-react-i18next"
import { AppFunctionComponent } from "../../../types"

const gatsbyLinkProps = [
  "activeClassName",
  "activeStyle",
  "innerRef",
  "partiallyActive",
  "replace",
  "to",
]

interface Props {
  to: string
  target: "_self" | "_blank" | "_parent" | "_top"
  rel: string
  children?: React.ReactNode
  className?: string
}

export const AppLink: AppFunctionComponent<Props> = ({
  children,
  className,
  to = "",
  target,
  rel = "noopener",
  ...props
}) => {
  if (
    target !== "_blank" &&
    to?.startsWith("/") &&
    !isLocaleIncludedToURL(to)
  ) {
    return (
      <TranslationLink className={className} to={resolveLink(to)} {...props}>
        {children}
      </TranslationLink>
    )
  } else if (target !== "_blank" && to?.startsWith("/")) {
    return (
      <Link className={className} to={resolveLink(to)} {...props}>
        {children}
      </Link>
    )
  } else if (to?.includes("#") && to?.startsWith("#")) {
    return (
      <Link className={className} to={to} {...props}>
        {children}
      </Link>
    )
  } else {
    const filteredProps = () => {
      return Object.keys(props)
        .filter((key) => !gatsbyLinkProps.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            // @ts-ignore
            [key]: props[key],
          }
        }, {})
    }
    return (
      <a
        className={className}
        href={to}
        target={
          to?.includes("find-your-best-fit") ||
          to?.includes("full-feature-list")
            ? "_blank"
            : isMuditaLink(to)
            ? "_self"
            : target || "_blank"
        }
        rel={
          to?.includes("find-your-best-fit") ||
          to?.includes("full-feature-list")
            ? "noopener"
            : rel
        }
        {...filteredProps()}
      >
        {children}
      </a>
    )
  }
}
